import axios, {AxiosError} from "axios";
import { API_URL } from "../constant";
import { RegisterResponse} from "../constant";
  
export async function getPaymentUrl(): Promise<RegisterResponse> {

    try {
        const token = localStorage.getItem("token")
        const data ={}

        const config = {
            headers: {
              Authorization: `Bearer ${token}`, // Bearer token
            },
          };
      
        const response = await axios.post(
          `${API_URL}api/accounting/getPaymentURLx`,
          data,
          config
        );
    
        if (response.status === 200)
        {
            return { success: true, msg: response.data["url"] };
        }
        else if (response.status === 500)
        {
            return { success: false, msg: "Internal Server Error" };
        }
        else{
            return { success: false, msg: "Unexpected status code" };
        }
    } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
            return { success: false, msg: `"Server Error:"${error.response.status}` };
        } else if (error.request) {
            return { success: false, msg: "No response received from server" };
        } else {
            return { success: false, msg: `Error:, ${error.message}` };
        }
    }
}